import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 事故
 */
const AccidentIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <defs>
          <clipPath id="AccidentIcon">
            <path
              d="M8.276,0H31.724A8.276,8.276,0,0,1,40,8.276V31.724A8.276,8.276,0,0,1,31.724,40H8.276A8.276,8.276,0,0,1,0,31.724V8.276A8.276,8.276,0,0,1,8.276,0Z"
              transform="translate(-155 -3377)"
              fill={CLIENT_SETTINGS.colors.background}
            />
          </clipPath>
        </defs>
        <g transform="translate(155 3377)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(-155 -3377)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <g clipPath="url(#AccidentIcon)">
            <g transform="translate(-270 -3535.869)">
              <g transform="translate(149.209 174.638)">
                <path
                  d="M552.232,355.7l8-1.623-1.1-5.447-5.454,1.106Z"
                  transform="translate(-552.232 -348.633)"
                  fill={CLIENT_SETTINGS.colors.main}
                />
              </g>
              <g transform="translate(135.924 170.14)">
                <path
                  d="M394.664,317.221a4.5,4.5,0,0,1-5.036-2.662l-.041-.1-3.341.677a1.942,1.942,0,0,1-2.287-1.516l-1.482-7.306a1.94,1.94,0,0,1,1.175-2.185l6.874-2.774,2.255-7.309a1.939,1.939,0,0,1,1.468-1.329l7.811-1.584.524,2.586-7.254,1.471-2.525,8.09-7.628,3.079,1.227,6.053,2.983-.6.02-.079a4.5,4.5,0,0,1,7.957-1.614l.049.065,8.172-1.657.524,2.586-7.845,1.591v.106A4.5,4.5,0,0,1,394.664,317.221Zm-1.235-6.09a1.719,1.719,0,1,0,2.026,1.343A1.721,1.721,0,0,0,393.429,311.131Z"
                  transform="translate(-382.438 -291.136)"
                  fill={CLIENT_SETTINGS.colors.main}
                />
              </g>
              <path
                d="M211.782,170.14l-4.02-2.2,1.958-4.145-4.547.581-.852-4.5-3.337,3.143-3.337-3.143-.852,4.5-4.547-.581,1.958,4.145-4.02,2.2,1.609.882h3.565l-1.609-.882,2.693-1.475-1.312-2.777,3.046.389.571-3.017,2.235,2.106,2.235-2.106.571,3.017,3.046-.389-1.312,2.777,2.693,1.475-2.693,1.475,1.312,2.777L203.79,174l-.484,2.558.878,3.721.137.129.852-4.5,4.547.581-1.958-4.145Z"
                transform="translate(-69.302 0)"
                fill={CLIENT_SETTINGS.colors.main}
              />
              <g transform="translate(115 172.94)">
                <g transform="translate(0 0)">
                  <path
                    d="M133.583,337.12l-1.992-8.44a2.191,2.191,0,0,0-2.146-1.751H115V347.5h5.5a4.9,4.9,0,0,0,9.6,0h1.334a2.191,2.191,0,0,0,2.191-2.191V337.56A2.189,2.189,0,0,0,133.583,337.12Zm-8.28,11.1a1.683,1.683,0,1,1,1.682-1.683A1.683,1.683,0,0,1,125.3,348.222Z"
                    transform="translate(-115 -326.929)"
                    fill={CLIENT_SETTINGS.colors.main}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default AccidentIcon
